import request from "../utils/request"

export function fetchFeedbackList(params = {}) {
  return request({
    url: "/admin/feedbacks",
    method: "get",
    params
  })
}

export function fetchFeedbackStats() {
  return request({
    url: "/admin/feedbacks/stats",
    method: "get"
  })
}

export function updateFeedbackHandling(id, data = {}) {
  return request({
    url: `/admin/feedbacks/${id}/handling`,
    method: "post",
    data
  })
}
